import * as React from 'react';

import type { UserFlow } from '../../../MedicareProAPI/Entities/User/UserFlow';

export interface FlowNavSingleProps {
  flow: UserFlow;
  selected: boolean;
  onClick: (flow: UserFlow) => void;
}

export const FlowNavSingle = (props: FlowNavSingleProps): React.JSX.Element => {
  const [flow, setFlow] = React.useState<UserFlow>(props.flow);
  const [selected, setSelected] = React.useState<boolean>(props.selected);

  React.useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  React.useEffect(() => {
    setFlow(props.flow);
  }, [props.flow]);

  const classList = ['small', 'card', 'p-2', 'mb-2', 'cp', 'card-tall', 'border', 'border-primary'];
  const badgeClassList = [
    'badge',
    'small',
    'float-right',
    'font-weight-normal',
    'text-white',
    'ml-1',
  ];

  if (selected === true) {
    classList.push('bg-primary');
    classList.push('text-white');
  }

  const badges = [];

  return (
    <div className={classList.join(' ')} onClick={(e) => props.onClick(flow)}>
      <div>
        {badges &&
          badges.map((badge) => <div className={badge.classList.join(' ')}>{badge.message}</div>)}

        <div style={{ fontSize: '10pt' }}>
          <strong>{flow.getName() || <em>New Automation</em>}</strong>
        </div>
        <div>{flow.getFlowStages() ? flow.getFlowStages().getTotalItems() : 0} stages</div>
      </div>
    </div>
  );
};
